import { defineComponent } from '../utils/alpine'

export default defineComponent(() => ({
  isMenuOpen: false,

  init() {
    // You could add logic here that runs when the header component initializes
    // For example, watching the menu state to add/remove a class from <body>
    this.$watch('isMenuOpen', (isOpen) => {
      if (isOpen) {
        document.body.classList.add('menu-is-open')
      } else {
        document.body.classList.remove('menu-is-open')
      }
    })
  },

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen
  },

  // Optional: Method to close menu specifically (e.g., on link click)
  closeMenu() {
    this.isMenuOpen = false
  },
}))
